import { BrandclubTermsAndConditions } from "@/components/pages/Auth/TermsAndConditions";
import { styled } from "@mui/material";
import { useCheckoutCartInfo } from "../../hooks/useCheckoutCartInfo";
import { CartTotal } from "./CartTotal";
import { RetailerErrorAndTerms } from "./ErrorAndTerms";
import { AsyncCheckoutCartProduct } from "./AsyncCheckoutCartProduct";
import { SubmitCheckoutButton } from "./SubmitCheckoutButton";

const CartContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  backgroundColor: "#f6f8fa",
  paddingTop: 37,
  paddingBottom: 32.8,
  paddingLeft: 32,
  paddingRight: 32,
  minWidth: 400,
  borderRadius: 8,
}));

const CartHeader = styled("div")({
  fontSize: "20px",
  fontWeight: 600,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const DesktopCart = () => {
  const { items: cartItems } = useCheckoutCartInfo();

  return (
    <CartContainer>
      <CartHeader>Order Summary</CartHeader>
      {cartItems.map((item) => (
        <AsyncCheckoutCartProduct key={item.stacklineSku} product={item} />
      ))}
      <RetailerErrorAndTerms />
      <CartTotal />
      <SubmitCheckoutButton />
      <BrandclubTermsAndConditions
        sx={{
          fontSize: 12,
          paddingX: "35px",
        }}
      />
    </CartContainer>
  );
};
